/*
 * @Description: 功能描述
 * @Version: 1.0
 * @Author: Yuchuan
 * @Date: 2022-01-17 14:44:14
 */
import Vue from 'vue'
import App from './App.vue'
import './index.scss'
import VueLazyLoad from 'vue-lazyload'
import imgLoading from '../../../public/static/img/loadingGif.gif'
Vue.config.productionTip = false
Vue.use(VueLazyLoad, {
  loading: imgLoading,
})
new Vue({
  // router,
  // store,
  render: (h) => h(App),
  mounted() {
    document.dispatchEvent(new Event('render-event'))
    // alert(`宽：${window.screen.width}高：${window.screen.height}`)
  },
}).$mount('#app')
